import { ReactNode, createContext, useState } from "react";
import { AuthProvider, AuthProviderProps } from "react-oidc-context";

import { IContextData, IContextState, IKeycloakConf } from "./Entities";

export const KeycloakAuthContext = createContext<IContextState>(
	{} as IContextState,
);

export function KeycloakProvider({
	configuration,
	children,
}: {
	configuration: IKeycloakConf;
	children: ReactNode;
}) {
	const initData: IContextData = {
		configuration: configuration,
	};
	const { hello, realm, clientId, redirectUri, acrValues, scope } =
		configuration;

	const replaceState = (_user: any | void): void => {
		window.history.replaceState({}, document.title, window.location.pathname);
	};

	const metadataUrl: string = `${hello}/realms/${realm}/.well-known/openid-configuration`;
	const authority: string = `${hello}/admin/realms`;

	const OidcConfig: AuthProviderProps = {
		metadataUrl: metadataUrl,
		authority: authority,
		client_id: clientId,
		redirect_uri:
			redirectUri && redirectUri?.length > 0
				? redirectUri
				: window.location.origin,
		loadUserInfo: true,
		onSigninCallback: replaceState,
		acr_values: acrValues,
		scope: scope,
	};

	const [data, setData] = useState<IContextData>(initData);

	return (
		<KeycloakAuthContext.Provider value={{ data: data, setData: setData }}>
			<AuthProvider {...OidcConfig}>{children}</AuthProvider>
		</KeycloakAuthContext.Provider>
	);
}
